export const en_US = {
  '返回': 'Back',
  '功放控制': 'Amplifier Control',
  '功放控制（已缩放适配一屏）': 'Amplifier control (scaled to fit screen)',
  '连接状态': 'Connection Status',
  'MCU连接状态': 'MCU Status',
  'Hamlib: Connected': 'Hamlib: Connected',
  'MUC: 未连接': 'MUC: Disconnected',
  'Connected': 'Connected',
  'Disconnected': 'Disconnected',
  '输出天线：': 'Output Antenna: ',
  '手动选择': 'Manual',
  '自动选择': 'Auto',
  '触发模式：': 'Trigger Mode: ',
  '接收状态': 'Receive',
  'PPT1': 'PPT1',
  'PPT2': 'PPT2',
  '输入功率触发': 'Input Power',
  '时间': 'Time',
  '系统同步': 'System Sync',
  '报警信息': 'Alarm',
  '设备报警': 'Device Alarm',
  '点击查看详情': 'Click for details',
  '清除报警': 'Clear Alarm',
  '清除报警指令已发送': 'Clear alarm command sent',
  '清除报警发送失败': 'Failed to send clear alarm',
  '密码验证': 'Password Verification',
  '请输入密码': 'Enter password',
  '提示：密码为 666': 'Hint: password is 666',
  '密码验证成功': 'Password verified',
  '密码错误，请重试': 'Wrong password, try again',
  '工程参数设置已保存': 'Engineering parameters saved',
  '工程参数设置': 'Engineering Parameters',
  '审计日志': 'Audit Log',
  '报警日志': 'Alarm Log',
  '更新审计日志指令已发送': 'Audit log query sent',
  '更新报警日志指令已发送': 'Alarm log query sent',
  '更新审计日志发送失败': 'Failed to send audit log query',
  '更新报警日志发送失败': 'Failed to send alarm log query',
  '启用报警信息': 'Enable alarm info',
  '按日志类型与精确时间范围查询设备事件': 'Query device events by log type and time range',
  '共 {count} 条': '{count} entries',
  '开始时间': 'Start time',
  '结束时间': 'End time',
  '选择开始时间': 'Select start time',
  '选择结束时间': 'Select end time',
  '数量': 'Count',
  '等级': 'Level',
  '消息': 'Message',
  '更新': 'Update',
  '确认': 'Confirm',
  '取消': 'Cancel',
  '确定': 'OK',
  '已连接': 'Connected',
  '未连接': 'Disconnected',
  '输入天线1': 'Input Antenna 1',
  '输入天线2': 'Input Antenna 2',
  '输入天线衰减器': 'Input Attenuator',
  '输入衰减器': 'Input Attenuator',
  '功放': 'Amplifier',
  '天调': 'Tuner',
  '关闭': 'Off',
  '开启': 'On',
  '调谐中': 'Tuning',
  '调谐失败': 'Tune Failed',
  '输出天线1': 'Output Antenna 1',
  '输出天线2': 'Output Antenna 2',
  '输出天线3': 'Output Antenna 3',
  '输出天线4': 'Output Antenna 4',
  '假负载': 'Dummy Load',
  '频率范围无效': 'Invalid frequency range',
  '天线配置保存失败': 'Failed to save antenna config',
  '频段未获取': 'Frequency Not Available',
  'Counter': 'Counter',
  'Hamlib': 'Hamlib',
  '滤波器：': 'Filter: ',
  '频段：': 'Band: ',
  '输入': 'Input',
  '输出': 'Output',
  '反向功率': 'Reverse Power',
  '驻波': 'SWR',
  '电压:': 'Voltage:',
  '电流:': 'Current:',
  '功率:': 'Power:',
  '温度:': 'Temperature:',
  '选择频段': 'Select Band',
  '编辑频段': 'Edit Band',
  '波段电压': 'Band Voltage',
  '频段名称': 'Band Name',
  '频段值': 'Band Value',
  '当前波段电压：': 'Current band voltage: ',
  '波段电压:': 'Band voltage: ',
  '自动模式': 'Auto Mode',
  '协议模式': 'Protocol Mode',
  '功放开启确认': 'Confirm PA On',
  '设备请求确认开启功放。': 'Device requests confirmation to turn on the amplifier.',
  '更新确认': 'Update Confirmation',
  '确认更新': 'Confirm Update',
  '设备检测到可用更新，是否开始下载并安装？': 'Update available. Download and install now?',
  '更新进度': 'Update Progress',
  '正在更新…': 'Updating…',
  '重启确认': 'Restart Confirmation',
  '立即重启': 'Restart Now',
  '稍后重启': 'Restart Later',
  '更新已安装完成，是否立即重启？': 'Update installed. Restart now?',
  '处理中…': 'Processing…',
  '输入正向功率保护': 'Input forward power protection',
  '输入反向功率保护': 'Input reverse power protection',
  '功放管输入过电压保护': 'PA tube input over-voltage protection',
  '功放管输出过电压保护': 'PA tube output over-voltage protection',
  '功放输出正向功率保护': 'PA output forward power protection',
  '功放管输出反向功率保护': 'PA tube output reverse power protection',
  '过流保护': 'Over-current protection',
  '过压保护': 'Over-voltage protection',
  '过温保护': 'Over-temperature protection',
  '高驻波': 'High SWR',
  '频率误差过大': 'Frequency error too large',
  '修改天线配置': 'Edit Antenna Config',
  '默认名称：{name}。名称留空并保存可恢复默认显示。频率单位为 Hz。': 'Default name: {name}. Leave empty and save to restore default. Frequency in Hz.',
  '自定义名称': 'Custom name',
  '开始频率 (Hz)': 'Start frequency (Hz)',
  '结束频率 (Hz)': 'End frequency (Hz)',
  '保存': 'Save',
  '保存中…': 'Saving…',
  '请输入有效的频率（Hz）': 'Enter a valid frequency (Hz)',
  '起始频率不能低于 {min} Hz': 'Start frequency cannot be below {min} Hz',
  '结束频率不能低于 {min} Hz': 'End frequency cannot be below {min} Hz',
  '起始频率不能大于结束频率': 'Start frequency cannot exceed end frequency',
  '电台设置': 'Radio Settings',
  '硬件菜单': 'Hardware Menu',
  '服务器设置': 'Server Settings',
  '端口:': 'Port:',
  '波特率:': 'Baud rate:',
  '电台:': 'Radio:',
  '电台选择': 'Select Radio',
  '硬件版本:': 'Firmware:',
  '软件版本:': 'Software:',
  '检查更新': 'Check Update',
  '串口:': 'Serial:',
  '连接:': 'Connection:',
  '重新连接': 'Reconnect',
  '重启软件': 'Restart Software',
  '配置': 'Configure',
  'MQTT 配置': 'MQTT Configuration',
  '串口选择': 'Serial Port',
  '波特率选择': 'Baud Rate',
  '共 {count} 个可用串口，点击切换 Hamlib 串口': '{count} serial port(s). Click to switch Hamlib port.',
  '共 {count} 个可选波特率，点击切换 Hamlib 波特率': '{count} baud rate(s). Click to switch Hamlib baud.',
  '共 {count} 个 Hamlib 机型': '{count} Hamlib rig(s)',
  '请选择电台': 'Select radio',
  '设备 ID 无效，无法重启软件': 'Invalid device ID, cannot restart software',
  '重启软件指令已发送': 'Restart software command sent',
  '重启软件指令发送失败': 'Failed to send restart software command',
  '可更新': 'Update available',
  '校准系数': 'Calibration',
  '其他': 'Other',
  '频段': 'Band',
  '电压校准系数': 'Voltage cal. coefficient',
  '电流校准系数': 'Current cal. coefficient',
  '频率校准系数': 'Frequency cal. coefficient',
  'VGS校准系数': 'VGS cal. coefficient',
  'DAC参考电压': 'DAC reference voltage',
  '偏置电压': 'Bias voltage',
  '截止频率': 'Cutoff frequency',
  '输入正向功率校准系数': 'Input FWD power cal.',
  '输入反向功率校准系数': 'Input REV power cal.',
  '输出正向功率校准系数': 'Output FWD power cal.',
  '输出反向功率校准系数': 'Output REV power cal.',
  '功放输入功率校准': 'PA input power cal.',
  '功放输出功率校准': 'PA output power cal.',
  '保护电压': 'Protection voltage',
  '保护电流': 'Protection current',
  '保护输入正向功率': 'Protect input FWD power',
  '保护输入反向功率': 'Protect input REV power',
  '保护输出正向功率': 'Protect output FWD power',
  '保护输出反向功率': 'Protect output REV power',
  '输入保护驻波比': 'Input protect SWR',
  '输出保护驻波比': 'Output protect SWR',
  '保护频率误差': 'Protect frequency error',
  '保护温度': 'Protect temperature',
  '驻波调谐值': 'SWR tune value',
  'PTT触发电功率': 'PTT trigger power',
  '恢复出厂设置': 'Factory Reset',
  '功能待对接': 'Feature pending integration',
  '天线切换失败': 'Antenna switch failed',
  'Command send/receive log': 'Command send/receive log',
  '输入 <100W': 'Input <100W',
  '减少 {label}': 'Decrease {label}',
  '增加 {label}': 'Increase {label}',
  '工程参数分页': 'Engineering parameter tabs',
  '校准参数': 'Calibration',
  '电压参数': 'Voltage',
  '保存参数': 'Save Parameters',
  '串口': 'Serial Port',
  '波特率': 'Baud rate',
  '请选择串口': 'Select serial port',
  '请选择波特率': 'Select baud rate',
  '请选择rig': 'Select rig',
  '频段校准系数': 'Band calibration coefficients',
  'vgs:': 'vgs:',
  'vgs频率:': 'vgs frequency:',
  '电压': 'Voltage',
  '输出正向功率比较电压': 'Output FWD power compare voltage',
  '输出反向功率比较电压': 'Output REV power compare voltage',
  '输入反向功率比较电压': 'Input REV power compare voltage',
  '输入正向功率比较电压': 'Input FWD power compare voltage',
  '过流比较电压': 'Over-current compare voltage',
  '功率触发PTT电压': 'PTT trigger voltage',
  '功放管输入功率比较电压': 'PA tube input power compare voltage',
  '功放管输出功率比较电压': 'PA tube output power compare voltage',
  '负载电阻': 'Load resistance',
  '频率测量值': 'Frequency measurement value',
  '天调电容选择值': 'Tuner capacitor selection',
  '天调电感选择值': 'Tuner inductor selection',
  '保护驻波比': 'Protection SWR',
  '工程参数设置界面': 'Engineering parameter settings',
} as const;
